import {
  Menu,
  MenuItem,
  Submenu,
  Input,
  Form,
  FormItem,
  Button,
  Table,
  TableColumn,
  Pagination,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  MessageBox,
  Message,
  RadioGroup,
  RadioButton,
  Dialog,
  Radio,
  DatePicker,
  TimePicker,
  Loading,
  Tag,
  Upload,
  Checkbox,
  Tabs,
  TabPane,
  Cascader,
  TimeSelect,
  Carousel,
  CarouselItem,
  Drawer,
  Autocomplete,
  CheckboxGroup,
  Step,
  Steps,
  Tooltip,
  Image,
  Row,
  Col,
  Rate,
  Popover
} from 'element-ui'

const elementUI = {
  install: function (Vue) {
    Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 }
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$message = Message
    Vue.prototype.$loading = Loading.service
    Vue.use(Loading.directive)
    Vue.use(Menu)
    Vue.use(MenuItem)
    Vue.use(Submenu)
    Vue.use(Input)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Button)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Pagination)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Dropdown)
    Vue.use(DropdownItem)
    Vue.use(DropdownMenu)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Radio)
    Vue.use(Dialog)
    Vue.use(DatePicker)
    Vue.use(TimePicker)
    Vue.use(Tag)
    Vue.use(Upload)
    Vue.use(Checkbox)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Cascader)
    Vue.use(TimeSelect)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(Drawer)
    Vue.use(Autocomplete)
    Vue.use(CheckboxGroup)
    Vue.use(Step)
    Vue.use(Steps)
    Vue.use(Tooltip)
    Vue.use(Image)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Rate)
    Vue.use(Popover)
  }
}
export default elementUI
